// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__37A54","backdrop":"Dialog_backdrop__bx4qW"};